<template>
  <div class="wrapper-grid" :class="'GRID-' + $store.getters.getData.template2">
    <h1 class="text-black-shadow">{{options.title}}</h1>
    <div class="container-grid">
      <div class="item" v-for="item in options.items" :key="item.id" :style="{ flexBasis: itemWidth + 'px'}">
        <router-link :to="{ name: options.route, params: { id: item.id }}" >
          <div class="image" :style="{ height:  itemHeight + 'px', width:  itemWidth + 'px' }">
            <img :class="{ 'border-radius-top': cardsSetting.text === 'outside'}"
              :data-src="item.image" loading="lazy" class="lazyload">

            <div class="data-float-text">
              <!-- play -->
              <span v-if="cardsSetting.play" class="icon"><icon name="regular/play-circle"></icon></span>
              <!-- text inside -->
              <span v-if="cardsSetting.text === 'inside'" class="name">{{item.name}}</span>
            </div>

            <!-- description -->
            <div class="card-description">
              <span>{{item.description}}</span>
            </div>

          </div>
          <div v-if="cardsSetting.text === 'outside'"
            class="text" :class="{ 'marquee': $store.getters.getData.template2 !== 'SUR'}"
            :style="{width:  itemWidth + 'px' }">
            <span>{{item.name}}</span>
          </div>
        </router-link>
      </div>
      <div class="item" v-for="(item, index) in extraItems" :key="index" :style="{ flexBasis: itemWidth + 'px'}"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Grid',
  props: ['options'],
  data () {
    return {
      itemWidth: false,
      itemHeight: false,
      extraItems: 0,
      noScale: false,
      cardsSetting: { // default
        text: 'outside', // outside, inside or ''
        play: false, // true or false
        trailer: false, // true or false
        favorite: 'top' // top or bottom
      }
    }
  },
  created: function () {
    this.setSize()

    if (this.$route.name === 'content-category') {
      // Plantilla pantalla anidada de contenidos (sub-category)
      if (this.$store.getters.getData.template2 === 'DFL') {
        this.cardsSetting = { text: 'outside', play: false, trailer: false, favorite: 'top' }
      } else if (this.$store.getters.getData.template2 === 'PIN' || this.$store.getters.getData.template1 === 'IMG') {
        this.cardsSetting = { text: '', play: false, trailer: false, favorite: 'bottom' }
      } else if (this.$store.getters.getData.template2 === 'PLY') {
        this.cardsSetting = { text: 'inside', play: true, trailer: true, favorite: 'top' }
      } else if (this.$store.getters.getData.template2 === 'PLN') {
        this.cardsSetting = { text: 'inside', play: true, trailer: false, favorite: 'top' }
      }
    }
  },
  mounted () {
    if ('loading' in HTMLImageElement.prototype) {
      // Si el navegador soporta lazy-load, tomamos todas las imágenes que tienen la clase `lazyload`, obtenemos el valor de su atributo `data-src` y lo inyectamos en el `src`.
      const images = this.$el.querySelectorAll('img.lazyload')
      images.forEach(img => { img.src = img.dataset.src })
    } else {
      // si no soporta lazy-load cargamos libreria
      import('lazysizes')
    }

    // redimensionar
    window.addEventListener('resize', () => { this.setSize() })
  },
  methods: {
    setSize () {
      // tamaño pantalla
      let windowWidth = window.innerWidth || document.documentElement.clientWidth
      // let windowHeight = window.innerHeight || document.documentElement.clientHeight

      //  tamaño tarjeta
      let cardWidth = ''; let cardHeight = ''
      if (this.options.card) {
        // especifico categoría
        cardWidth = this.options.card.width_ios
        cardHeight = this.options.card.height_ios
      } else if (this.options.type === 'card-categories' && this.$store.getters.getData.card_categories) {
        // categorías contenidos
        cardWidth = this.$store.getters.getData.card_categories.width_ios
        cardHeight = this.$store.getters.getData.card_categories.height_ios
      } else if (this.options.type === 'card-contents' && this.$store.getters.getData.card_contents) {
        // contenidos
        cardWidth = this.$store.getters.getData.card_contents.width_ios
        cardHeight = this.$store.getters.getData.card_contents.height_ios
      } else {
        // default
        cardWidth = 432
        cardHeight = 243
      }

      // insertamos numero de elementos max en fila para alinear última fila
      if (!this.extraItems) {
        // 1825 = 1920 - 2rem en full HD
        this.extraItems = Math.trunc(1825 / cardWidth)
      }

      // base FULL-HD
      this.itemWidth = (windowWidth * cardWidth) / 1920
      // this.itemHeight = (windowHeight * cardHeight) / 1080

      // breakpoints
      if (windowWidth < 700) { this.itemWidth = this.itemWidth * 1.8 }
      if (windowWidth < 450) { this.itemWidth = this.itemWidth * 1.9 }
      if (this.itemWidth > windowWidth) { this.itemWidth = windowWidth * 0.92 }
      if (cardWidth > 1700) { this.noScale = true }

      // calcular tamaño manteniendo relación de aspecto
      // (original height / original width) x new width = new height
      this.itemHeight = (cardHeight / cardWidth) * this.itemWidth
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper-grid
  position: relative
  padding:  2rem; // si cambia hay que cambiar 1825

  h1
    margin-left: 4rem;
    font-size: 2.3rem;
    margin-top: 0

  .container-grid
    display: flex
    flex-wrap: wrap
    justify-content: center

    .item
      flex: 0 0 auto
      margin-top: .2rem
      margin-bottom: 2rem
      margin-left: .2rem
      margin-right: .2rem
      transition: transform .5s

      &:hover
        transform: scale(1.09)
        transition: transform .2s
        z-index: 4

      a
        display: block

        .image
          position: relative;

          img
            object-fit: cover
            width: 100%
            height: 100%
            border-radius: .2rem

            &.border-radius-top
              border-radius: .2rem .2rem 0 0

          .data-float-text
            position: absolute
            bottom: 0
            left: 0
            width: 100%
            padding: 5px 8px 5px 8px
            color: #ffff;

            span
              float: left
              width: 100%

            .icon
              font-size: 3rem
              filter: drop-shadow(0 0 0.1rem black)

            .name
              font-size: 1.1rem
              font-weight: bold
              text-shadow: #000 0.1em 0.1em 0.2em;

              // overflow ellipsis una línea
              white-space: nowrap
              overflow: hidden
              text-overflow: ellipsis

        .text
          display: block
          font-size: 1.3rem;
          padding-left: 1rem
          padding-right: 1rem

          // tmpl default
          color: #373a3c
          background-color: #ffffff
          border-radius:  0 0 .2rem .2rem

          white-space: nowrap
          overflow: hidden
          text-overflow: ellipsis

// templates
.GRID-PIN
  .item
    margin-left: 1px!important
    margin-right: 1px!important

.GRID-SUR
  .item
    margin-left: .45rem!important
    margin-right: .45rem!important

  .image
    position: relative

    img
      position: relative
      border-radius: .8rem!important

    &:before
      content: "";
      position: absolute;
      top: 0
      bottom: 0
      left: 0
      right: 0
      transform: translateY(1.4rem)
      background-color: black;
      -webkit-filter: blur(20px);

  .text
    position: relative!important
    text-align: center!important
    font-size: 1.1rem!important
    color: #fff!important
    text-shadow: #000000 0.1em 0.1em 0.2em!important
    white-space: normal!important;
    background-color: transparent!important

    // ellipsis
    // overflow: hidden
    // text-overflow: ellipsis

    display: -webkit-box
    // navegadores nuevos
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    // navegadores antiguos
    line-height: 1.2em
    height: 2.4em       // height is 2x line-height, so two lines will display

.card-description
  position: absolute
  top: 0
  left: 0
  height: 100%
  width: 100%
  padding: 1rem
  font-size: 1.1rem
  color: #fff
  background-color: rgba(0,0,0,.8);

  opacity: 0
  display: none!important

  span
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    height: 6rem;
    line-height: 2rem;

.item:hover .card-description
  opacity: 1;
  transition: opacity .35s ease-out;
</style>



// WEBPACK FOOTER //
// src/components/Grid.vue